import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ItemContent from '../../components/ItemContent/ItemContent';
import { IEditForm } from '../../types/interfaces/IEditForm';
import { NSProfile } from '../../types/interfaces/NSProfile';
import tPaths from '../../utils/tPaths';
import { endpoints } from '../../utils/endpoints';
import { EPaths } from '../../types/enums/EPaths';

const MyProfile = () => {
  const { t } = useTranslation();

  const contentMapper = useCallback(
    (data: NSProfile.IData): IEditForm[][] => [
      [
        {
          type: 'title',
          label: t(tPaths.profile.contactInformation),
          fieldName: 'contactInformation',
        },
        {
          type: 'input',
          label: t(tPaths.editFormLabels.name),
          fieldName: 'nameSurname',
          initialValue: data.nameSurname,
        },
        {
          type: 'input',
          label: t(tPaths.editFormLabels.email),
          fieldName: 'email',
          initialValue: data.email,
          textFieldType: 'email',
        },
        {
          type: 'title',
          label: t(tPaths.profile.password),
          fieldName: 'password',
        },
        {
          type: 'input',
          label: t(tPaths.editFormLabels.oldPassword),
          fieldName: 'oldPassword',
          textFieldType: 'password',
        },
        {
          type: 'input',
          label: t(tPaths.editFormLabels.newPassword),
          fieldName: 'newPassword',
          textFieldType: 'password',
        },
        {
          type: 'input',
          label: t(tPaths.editFormLabels.confirmPassword),
          fieldName: 'confirmPassword',
          textFieldType: 'password',
        },
      ],
    ],
    [t],
  );

  const updateDataFormatter = useCallback(
    (fields: any) => ({
      email: fields.email.value,
      nameSurname: fields.nameSurname.value,
      newPassword: fields.newPassword.value,
      oldPassword: fields.oldPassword.value,
    }),
    [],
  );

  const handleInputValidation = useCallback((fields) => {
    if (
      fields.newPassword.value.length &&
      fields.newPassword.value !== fields.confirmPassword.value
    ) {
      return { fieldsErrors: [{ field: 'confirmPassword', errorText: 'Password does not match' }] };
    }
  }, []);

  return (
    <ItemContent
      path={EPaths.MyProfile}
      updateDataFormatter={updateDataFormatter}
      contentMapper={contentMapper}
      backButton={false}
      apiUrl={endpoints.profile}
      onInputValidation={handleInputValidation}
    />
  );
};

export default MyProfile;
